import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "q-ml-sm"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_btn_group = _resolveComponent("q-btn-group")!
  const _component_FaceDetailDialog = _resolveComponent("FaceDetailDialog")!

  return (_ctx.isGranted('VIEW_PERSONS'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_q_btn_group, { rounded: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_btn, {
              icon: "fa fa-users",
              color: _ctx.personIds.length ? 'primary' : undefined,
              "text-color": _ctx.personIds.length ? 'white' : undefined,
              class: "q-py-sm",
              onClick: _ctx.openPersonFilter
            }, {
              default: _withCtx(() => [
                (_ctx.personIds.length)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.personIds.length), 1))
                  : _createCommentVNode("", true),
                _createVNode(_component_q_tooltip, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Filter by People")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["color", "text-color", "onClick"]),
            (_ctx.personIds.length)
              ? (_openBlock(), _createBlock(_component_q_btn, {
                  key: 0,
                  icon: "fa fa-times",
                  class: "q-py-sm",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:person-ids', [])))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_tooltip, null, {
                      default: _withCtx(() => [
                        _createTextVNode("Clear person filter")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_FaceDetailDialog, {
          ref: "faceDetail",
          "client-id": _ctx.clientId,
          onViewPerson: _ctx.openPerson
        }, null, 8, ["client-id", "onViewPerson"])
      ]))
    : _createCommentVNode("", true)
}